/* unplugin-vue-components disabled */import script from "./addOrEditVoucher.vue?vue&type=script&setup=true&lang=ts"
export * from "./addOrEditVoucher.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__